import styled from "styled-components";

type TextType = {
    color: string;
};

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px 0;
`;

export const TitleGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const TitleRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const Title = styled.h1<TextType>`
  margin: 0;
  font-size: 18px;
  font-weight: bold;
  color: ${(props) => props.color};
`;

export const Subtitle = styled.span<TextType>`
  font-size: 13px;
  color: ${(props) => props.color};
`;

export const ActionsGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;
